import { render, staticRenderFns } from "./totalReadCount.vue?vue&type=template&id=b18f801c&scoped=true&"
import script from "./totalReadCount.vue?vue&type=script&lang=ts&"
export * from "./totalReadCount.vue?vue&type=script&lang=ts&"
import style0 from "./totalReadCount.vue?vue&type=style&index=0&id=b18f801c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18f801c",
  null
  
)

export default component.exports